import { useToast } from "../../shared/composables/useToast";
export class ToastNotificationService {
    constructor() {
        Object.defineProperty(this, "toast", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: useToast()
        });
    }
    showSuccess(message) {
        this.toast.showSuccess(message);
    }
    showError(message) {
        this.toast.showError(message);
    }
    showInfo(message) {
        this.toast.showInfo(message);
    }
}
